import { Modal, Spinner } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { projectLogoLight, projectPrimaryColor } from "../../generalConfigs";
import validator from "validator";
import useAuth from "../../hooks/useAuth";
import useExternalAuth from "../../hooks/useExternalAuth";
import useStoredImage from "../../hooks/useStoredImage";

export default function Login() {
  const [emailValue, setEmailValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isExternalAuthLoading, setIsExternalAuthLoading] = useState(false);
  const history = useHistory();
  const { doLogin: login, isAuthenticated } = useAuth();
  const { getRedirectURL } = useExternalAuth();
  const { getCommonImageSrc } = useStoredImage();

  if (isAuthenticated()) {
    history.push("/dashboard");
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMsg("");

    if (validator.isEmail(emailValue)) {
      let doLogin = await login({
        email: emailValue,
        password: passwordValue,
      });
      if (doLogin) {
        let { status, msg } = doLogin;
        if (status === 1) {
          //Everything went well, let's create a token.
          return history.push("/welcome");
        } else if (msg === "User inactive") {
          //Inactive user
          setErrorMsg(
            "Seu usuário está inativo, por favor, entre em contato conosco."
          );
          setIsLoading(false);
        } else {
          //Incorrect password
          setErrorMsg(
            "E-mail ou senha incorretos, verifique os dados informados."
          );
          setIsLoading(false);
        }
      } else {
        setErrorMsg(
          "E-mail ou senha incorretos, verifique os dados informados."
        );
        setIsLoading(false);
      }
    } else {
      setErrorMsg("Verifique o campo de email e tente novamente.");
      setIsLoading(false);
    }
  };

  async function handleRedirectExternalAuth(provider) {
    setIsExternalAuthLoading(true);

    if (provider === "google") {
      const redirectUrl = await getRedirectURL("google");

      if (redirectUrl) {
        window.location.replace(redirectUrl);
      }
    }

    setIsExternalAuthLoading(false);
  }

  return (
    <Modal size="lg" fullscreen={true} show={true}>
      <div style={{ backgroundColor: "#343640", borderRadius: "0 10px 10px 0" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 shadow-lg">
              <div className="hero-wrap d-flex align-items-center rounded-3 rounded-end-0 h-100">
                <div className="hero-mask opacity-9 bg-primary" />
                <div className="hero-bg hero-bg-scroll" />
                <div className="hero-content mx-auto w-100 h-100 d-flex flex-column">
                  <div className="row g-0">
                    <div className="col-11 col-lg-10 mx-auto">
                      <div className="mt-3">{projectLogoLight}</div>
                    </div>
                  </div>
                  <div className={isMobile ? "row g-0 my-3" : "row g-0 my-4"}>
                    <div className="col-11 col-lg-10 mx-auto">
                      <h1 className="text-11" style={{ color: "#e0e0e0" }}>
                        Já é <span className="markText-animation">Fato?</span>
                      </h1>
                      <p
                        className="text-5 lh-base mb-4"
                        style={{ color: "#e0e0e0" }}
                      >
                        Faça login utilizando seu e-mail e senha para ter acesso
                        a melhor plataforma de análise de investimentos baseada
                        em machine learning.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-6 shadow-lg d-flex align-items-center rounded-3 rounded-start-0"
              style={{
                backgroundColor: "var(--bg-6)",
                borderRadius: 10,
              }}
            >
              {isLoading ? (
                loadingSkeleton()
              ) : (
                <div className="container my-auto py-4">
                  <div className="row">
                    <div className="col-11 col-lg-10 mx-auto">
                      <h3 className="text-black text-center mb-3 ">Login</h3>

                      <form className="form" onSubmit={handleSubmit}>
                        <div className="mb-3">
                          <label className="form-label text-black">
                            E-mail
                          </label>
                          <input
                            type="email"
                            value={emailValue}
                            onChange={(e) => setEmailValue(e.target.value)}
                            className="form-control"
                            required
                            minLength={10}
                            placeholder="Insira seu e-mail"
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label text-black">Senha</label>
                          <input
                            type="password"
                            value={passwordValue}
                            onChange={(e) => setPasswordValue(e.target.value)}
                            className="form-control"
                            minLength={7}
                            required
                            placeholder="Insira sua senha"
                          />
                        </div>

                        <div className="d-grid my-4 d-flex flex-column align-items-center">
                          {errorMsg !== "" && (
                            <span
                              className="my-2"
                              style={{
                                color: "red",
                                textAlign: "center",
                              }}
                            >
                              {errorMsg}
                            </span>
                          )}

                          <button
                            className="btn btn-primary"
                            style={{
                              borderRadius: 10,
                              width: "50%",
                              backgroundColor: projectPrimaryColor,
                            }}
                            type="submit"
                          >
                            Entrar
                          </button>
                          <p className="text-2 text-center text-black my-2">
                            <Link to="/password-recovery">
                              Esqueci minha senha
                            </Link>
                          </p>
                        </div>
                      </form>
                      <div className="d-flex align-items-center my-1">
                        <hr className="flex-grow-1 bg-dark-4" />
                        <span className="mx-2 text-2 text-muted">
                          Continue utilizando outras plataformas
                        </span>
                        <hr className="flex-grow-1 bg-dark-4" />
                      </div>
                      {isExternalAuthLoading ? (
                        // Loading external auth
                        <div className="d-flex flex-column align-items-center mb-4">
                          <button
                            className="btn btn-outline-black"
                            type="button"
                            style={{
                              textTransform: "none",
                              borderRadius: 15,
                              color: "var(--text-1)",
                              borderColor: "#969dab",
                              cursor: "default",
                            }}
                          >
                            <Spinner animation="border" size="sm" />
                          </button>
                        </div>
                      ) : (
                        // External auth buttons
                        <div className="d-flex flex-column align-items-center mb-4">
                          <button
                            className="btn btn-outline-black"
                            onClick={() => handleRedirectExternalAuth("google")}
                            style={{
                              textTransform: "none",
                              borderRadius: 15,
                              color: "var(--text-1)",
                              borderColor: "#969dab",
                            }}
                          >
                            <img
                              width="20px"
                              style={{ marginBottom: 1, marginRight: 5 }}
                              alt="Google Sign-in"
                              src={getCommonImageSrc("Google__G__Logo.svg.png")}
                            />
                            Continuar com Google
                          </button>
                        </div>
                      )}

                      <p className="text-2 text-center text-black mb-0">
                        Ainda não é Fato?
                        <span className="mx-1" href="/">
                          <Link to="/signup">Cadastre-se</Link>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

const loadingSkeleton = () => {
  return (
    <div className="container my-auto py-4">
      <div className="row">
        <div className="col-11 col-lg-10 mx-auto">
          <h3
            className="text-black text-center mb-3"
            style={{ minHeight: "20vh" }}
          >
            <Spinner animation="border" style={{ marginTop: "20%" }} />
          </h3>
        </div>
      </div>
    </div>
  );
};
